export class RenderItem {
  public x = 0.0;
  public y = 0.0;
  public width = 1.0;
  public height = 1.0;
  public id = '';
  public label = '';
  public labelColor = '';
  public fill = '';
  public stroke = '';

  public constructor(id: string, x: number, y: number, width: number, height: number, label: string, labelColor: string, fill: string, stroke: string) {
    this.id = id;
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.label = label;
    this.labelColor = labelColor;
    this.fill = fill;
    this.stroke = stroke;
  }
}
